<template>
  <div>
    <b-row class="justify-content-end">
      <b-col md="3">
        <b-button
          v-b-modal.client-modal
          variant="primary"
          class="button-mt"
          :disabled="!selected_rows.length || !sms_template"
          @click="before_sending_modal = true"
        >
          <feather-icon icon="ZapIcon" />
          {{ $t('sms.send') }}
        </b-button>
        <!-- <b-button
          v-b-modal.add-new-client
          variant="success"
          class="button-mt ml-2"
        >
          <feather-icon icon="TrelloIcon" />
          Добавить
        </b-button> -->
      </b-col>

      <!-- <b-col md="2">
        <b-form-group :label="$t('sms.manager')+':'">
          <v-select
            v-model="filter.manager"
            :options="getUsers.results"
            label="first_name"
            :reduce="user => user.id"
            class="bg-white"
            @input="refresh"
          />
        </b-form-group>
      </b-col> -->
      <b-col md="3">
        <b-form-group :label="$t('reports.related_person')">
          <v-select
            v-model="filter.related_person"
            :options="relatedPerson"
            :get-option-label="(el) => el[$i18n.locale]"
            class="bg-white"
            :reduce="(el) => el.uz"
            @input="refresh"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group :label="$t('sms.created_from') + ':'">
          <flat-pickr
            v-model="filter.from_date"
            class="form-control bg-white"
            style="max-width: 250px;"
            :config="configdateTimePicker"
            @on-change="refresh"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group :label="$t('clients.date_of_creation') + ':'">
          <flat-pickr
            v-model="filter.to_date"
            class="form-control bg-white"
            style="max-width: 250px;"
            :config="configdateTimePicker"
            @on-change="refresh"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group :label="$t('sms.sms_template') + ':'">
          <v-select
            v-model="sms_template"
            :options="GET_MAIL_TEMPLATES"
            class="bg-white"
            label="title"
          />
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group :label="$t('navbars.by_objects')">
          <v-select
            v-model="filter.object_id"
            :options="getAllObjects"
            label="title"
            class="bg-white"
            :reduce="(object) => object.id"
            @input="refresh"
          />
        </b-form-group>
      </b-col>
      <!-- <b-col md="2">
        <b-form-group :label="$t('sms.gender')+':'">
          <v-select
            v-model="filter.gender"
            :options="genderOptions"
            class="bg-white"
            :reduce="gender => gender.id"
            :get-option-label="option => option.title[$i18n.locale]"
            @input="refresh"
          />
        </b-form-group>
      </b-col> -->
      <!-- <b-col md="3">
        <b-form-group :label="$t('sms.ownership')+':'">
          <v-select
            v-model="filter.entity"
            :options="entityOptions"
            class="bg-white"
            :reduce="entity => entity.id"
            label="title"
            @input="refresh"
          />
        </b-form-group>
      </b-col> -->

      <b-col md="3">
        <b-form-group :label="$t('reports.by_debts')">
          <v-select
            v-model="filter.is_debt"
            :options="filterTypeOptions"
            label="title"
            class="bg-white"
            :reduce="(type) => type.id"
            @input="refresh"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <AppSearchInput
          :label="$t('generals.search')"
          :placeholder="$t('generals.search')"
          @callback="search"
        />
      </b-col>
    </b-row>
    <b-table
      id="client-table"
      ref="selectableTable"
      :items="items"
      :fields="fields"
      :tbody-tr-class="['tableRowClass']"
      show-empty
      small
      :current-page="currentPage"
      @row-clicked="rowClicked"
      :busy="loading"
    >
      <template #head()="data">
        <span>{{ $t(data.label) }}</span>
      </template>
      <template #empty>
        <b-spinner v-if="loading" />
        <span v-else> {{ $t('objects.no_data') }} </span>
      </template>
      <template #head(selected)>
        <div class="d-flex justify-content-center">
          <b-form-checkbox
            v-model="all_selected"
            class="mx-auto pl-2"
            @input="selectAll"
          >
            {{ $t('sms.all') }}
          </b-form-checkbox>
        </div>
      </template>

      <!-- <template #cell(selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not selected</span>
        </template>
      </template> -->

      <template #cell(selected)="{ item }">
        <!-- <b-form-checkbox v-model="item[key]" /> -->
        <!-- <b-form-checkbox
          :value="selected_rows.includes(item.id)"
          @change="rowClicked(item)"
        /> -->
        <!-- {{ selected_rows.includes(item.id) }} -->
        <template v-if="selected_rows.includes(item.id)">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
      </template>
      <template #cell(paid)="props">
        {{ $_moneyFormatter(props.item.paid) }}
      </template>
      <template #cell(price)="props">
        {{ $_moneyFormatter(props.item.price) }}
      </template>
      <template #cell(amount)="props">
        {{ $_moneyFormatter(props.item.amount) }}
      </template>
      <template #cell(debt)="props">
        {{ $_moneyFormatter(props.item.debt) }}
      </template>
      <template #cell(created_at)="props">
        <span v-if="props.item.created_at" style="white-space: nowrap">
          {{ props.item.created_at }}
        </span>
      </template>
      <template #cell(related_person)="{value}">
        {{ value[$i18n.locale] }}
      </template>
      <template #cell(name)="props">
        <span v-if="props.item.name !== 'total'">
          {{ props.item.name }}
        </span>
        <h4 v-else class="font-weight-bold text-uppercase">
          Итог
        </h4>
      </template>
      <template #cell(actions)="props">
        <div
          v-if="props.item.name !== 'total'"
          class="d-flex justify-content-around"
        >
          <b-button
            v-b-modal.auto-sms-modal
            variant="success"
            size="sm"
            @click="$router.push(`/clients/${props.item.id}`)"
          >
            <feather-icon icon="ChevronsRightIcon" />
          </b-button>
          <b-button
            variant="warning"
            size="sm"
            @click="() => $router.push('/finance')"
          >
            <feather-icon icon="DollarSignIcon" />
          </b-button>
        </div>
      </template>
    </b-table>
    <!-- pagination -->
    <!-- style="border-top: 1px solid lightgrey;" -->
    <div
      class="d-flex justify-content-between align-items-center flex-wrap mb-75 shadow rounded bg-white p-1"
    >
      <div class="d-flex align-items-center mb-0">
        <span class="text-nowrap text-black ml-1">
          {{ $t('generals.show_from') }}
        </span>
        <b-form-select
          v-model="perPage"
          :options="['10', '15', '50']"
          class="mx-1 text-black"
          @change="changePerPage"
        />
        <!-- <span class="text-nowrap text-black"> {{$t('pagination.entries')}} </span> -->
      </div>
      <div class="mb-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          first-number
          last-number
          align="right"
          prev-class="prev-item"
          next-class="next-item"
          class="mt-1 mb-0"
          @change="changePage"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </div>
    </div>
    <b-modal
      v-model="before_sending_modal"
      :title="$t('generals.please_confirm')"
      :ok-title="$t('generals.approved')"
      :cancel-title="$t('generals.cancel')"
      @ok="sendBtnClick"
    >
      <div>
        {{ $t('sms.sms_sending') }}
        {{ all_selected ? getClientsList.count : selected_rows.length
        }}{{ $t('sms.to_client') }}
      </div>
      <div>
        <b-tabs v-if="sms_template" content-class="pt-1" fill>
          <b-tab title="Uz">
            <pre class="mt-1 w-100 sms-body">
              {{ sms_template.body.uz }}
            </pre>
          </b-tab>
          <b-tab title="Ru">
            <pre class="mt-1 w-100 sms-body">
              {{ sms_template.body.ru }}
            </pre>
          </b-tab>
        </b-tabs>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import {
  BFormGroup,
  BRow,
  BCol,
  BButton,
  BTable,
  BTabs,
  BTab,
  // BBadge,
  BPagination,
  BFormSelect,
  VBTooltip,
  VBToggle,
  BFormCheckbox,
  BSpinner,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Russian } from 'flatpickr/dist/l10n/ru'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import AppSearchInput from '../Clients/components/AppSearchInput.vue'
import formatters from '@/mixins/extra'

export default {
  components: {
    BButton,
    FeatherIcon,
    BPagination,
    BFormSelect,
    BFormGroup,
    BRow,
    BCol,
    VSelect,
    BTable,
    // BBadge,
    BSpinner,
    AppSearchInput,
    flatPickr,
    BFormCheckbox,
    BTabs,
    BTab,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
    'b-toggle': VBToggle,
  },
  mixins: [formatters],
  props: {
    update: {
      type: String,
      required: false,
      default: '',
    },
    query: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      loading: true,
      items: [],
      before_sending_modal: false,
      selected_rows: [],
      all_selected: null,
      filter: {
        search: '',
        status_of_client: null,
        manager: null,
        entity: null,
        from_date: '',
        to_date: '',
        related_person: '',
        is_debt: '',
        object_id: '',
      },
      sms_template: null,
      relatedPerson: [
        { ru: 'Ифтихор', uz: 'Iftixor' },
        { ru: 'Элбек', uz: 'Elbek' },
        { ru: 'Гиёс', uz: 'Giyos' },
        { ru: 'Шуҳрат', uz: 'Shuhrat' },
        { ru: 'Элёр', uz: 'Elyor' },
        { ru: 'Феруз', uz: 'Feruz' },
        { ru: 'Ходим', uz: 'Xodim' },
        { ru: 'Нет оплаты', uz: 'Tolanmagan' },
        { ru: 'Бартер', uz: 'Barter' },
        { ru: 'Прочие', uz: 'Boshqalar' },
      ],
      entityOptions: [
        {
          title: this.$t('sms.entity'),
          id: 'yuridiskiy',
        },
        {
          title: this.$t('sms.natural_person'),
          id: 'fizichiskiy',
        },
      ],
      genderOptions: [
        {
          title: {
            uz: 'Erkak',
            ru: 'Мужской',
            en: 'Male',
          },
          id: 'man',
        },
        {
          title: {
            uz: 'Ayol',
            ru: 'Женский',
            en: 'Female',
          },
          id: 'woman',
        },
      ],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      filterTypeOptions: [
        { title: this.$i18n.t('reports.debts_exist'), id: true },
        { title: this.$i18n.t('reports.no_debts'), id: false },
      ],
      fields: [
        {
          label: 'Select All',
          key: 'selected',
          thClass: 'tableHeadClass',
        },
        {
          key: 'name',
          label: 'contract.investor_name',
          formatter(val) {
            return val !== 'total' ? val : ''
          },
          thClass: 'tableHeadClass text-center',
        },
        {
          key: 'contract_number',
          label: 'contract.contract_number',
          thClass: 'tableHeadClass',
        },
        {
          key: 'price',
          label: 'contract.total_price',
          thClass: 'tableHeadClass',
        },
        {
          key: 'created_at',
          label: 'contract.created_at',
          thClass: 'tableHeadClass',
        },
        {
          key: 'send_date',
          label: 'contract.send_date',
          thClass: 'tableHeadClass',
        },
        {
          key: 'paid',
          label: 'reports.paid_amount',
          thClass: 'tableHeadClass',
        },
        {
          key: 'amount',
          label: 'reports.unpaid_amount_installment',
          thClass: 'tableHeadClass',
        },
        {
          key: 'debt',
          label: 'reports.total_debt',
          thClass: 'tableHeadClass',
        },
        {
          key: 'related_person',
          label: 'reports.related_person',
          thClass: 'tableHeadClass',
        },
      ],
      configdateTimePicker: {
        altInput: true,
        altFormat: 'd.m.Y',
        dateFormat: 'Y-m-d',
        locale: Russian,
      },
      delay: 200,
    }
  },
  computed: {
    ...mapGetters('clients', [
      'getClientsList',
      'getStatusClient',
      'getUsers',
      'GET_CLIENT_GROUPS',
    ]),
    ...mapGetters('sms', ['GET_MAIL_TEMPLATES']),
    ...mapGetters('objects', ['GET_OBJECTS']),
    statusesclient() {
      return this.getStatusClient.map((status) => ({
        id: status.id,
        title: status.title.ru,
      }))
    },
    getAllObjects() {
      return [{ title: 'все', id: 'all' }].concat(this.GET_OBJECTS)
    },
  },

  mounted() {
    this.refresh()
    this.GET_STATUS_CLIENT()
    this.FETCH_USERS_LIST({ is_employee: true })
    this.FETCH_CLIENT_GROUPS()
    this.FETCH_MAIL_TEMPLATES()
    this.FETCH_OBJECTS()
  },

  methods: {
    ...mapActions('clients', [
      'FETCH_CLIENTS_LIST',
      'GET_STATUS_CLIENT',
      'FETCH_USERS_LIST',
      'FETCH_CLIENT_GROUPS',
    ]),
    ...mapActions('sms', ['FETCH_MAIL_TEMPLATES', 'SEND_SMS']),
    ...mapActions('objects', [
      'FETCH_OBJECT_CONTRACTS_REPORT',
      'FETCH_OBJECTS',
    ]),
    innParsing(inn) {
      return `${inn.slice(0, 3)} ${inn.slice(3, 6)} ${inn.slice(6, 9)}`
    },

    search(text) {
      this.filter.search = text
      this.refresh()
    },

    rowClicked(item) {
      // if (this.selected_rows.includes(item.id)) {
      //   this.all_selected = false
      // }
      if (!this.all_selected) {
        if (!this.selected_rows.includes(item.id)) {
          this.selected_rows.push(item.id)
        } else {
          this.selected_rows = this.selected_rows.filter((el) => el !== item.id)
        }
      }
      // if (item.selected) {
      //   this.$set(item, 'selected', false)
      // } else {
      //   this.$set(item, 'selected', true)
      // }
    },

    selectAll(val) {
      if (val) {
        // this.$refs.selectableTable.selectAllRows()
        this.items.forEach((el) => {
          // this.$set(el, 'selected', true)
          if (!this.selected_rows.includes(el.id)) {
            this.selected_rows.push(el.id)
          }
        })
      } else {
        this.items.forEach((el) => {
          this.$set(el, 'selected', false)
        })
        this.selected_rows = []
        // this.$refs.selectableTable.clearSelected()
      }
    },

    onRowSelected(data) {
      if (data.length) {
        data.forEach((element) => {
          if (!this.selected_rows.includes(element.id)) {
            this.selected_rows.push(element.id)
          }
        })
        // this.selected_rows.push(...data.map(el => {
        //   if (!this.selected_rows.includes(el.id)) {
        //     return el.id
        //   }
        //   return undefined
        // }))
      }
      // if (this)
    },

    async refresh() {
      this.loading = true
      clearTimeout(this.delay)
      this.delay = setTimeout(async () => {
        const { data } = await this.FETCH_OBJECT_CONTRACTS_REPORT(this.filter)
        this.items = data.results
        this.totalRows = data.count

        if (this.all_selected) {
          // this.onRowSelected(this.items)
          // this.$refs.selectableTable.selectedRows = this.items
          this.items.forEach((el) => {
            // this.$set(el, 'selected', true)
            this.selected_rows.push(el.id)
          })
          // this.$nextTick(() => {
          //   this.$refs.selectableTable.selectAllRows()
          // })
        }
        this.loading = false
      }, 200)
    },
    changePage(value) {
      this.filter.page = value
      this.currentPage = value
      this.refresh()
    },
    changePerPage() {
      this.filter.page = 1
      this.filter.page_size = this.perPage
      this.refresh()
    },
    sendBtnClick() {
      const data = {
        is_multiple: this.all_selected,
        template: this.sms_template.id,
        contracts: this.selected_rows.length && this.selected_rows,
      }
      this.SEND_SMS({ data, params: this.filter })
        .then(() => {
          this.$_successToast(this.$t('sms.successfully_sent'))
        })
        .catch(() => {
          this.$_errorToast(this.$t('generals.error'))
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

#client-table {
  border-collapse: separate;
  border-spacing: 0 1rem;
}
.tableRowClass {
  background: white;
  transform: translateY(5px);
  transition: all 0.5s ease-in-out;
  text-align: center;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
  // -webkit-box-shadow:  0 4px 20px 0px lightgrey;  /* Safari 3-4, iOS 4.0.2 - 4.2, Android 2.3+ */
  // -moz-box-shadow:     0 4px 20px 0px lightgrey;  /* Firefox 3.5 - 3.6 */
  // box-shadow:          0 4px 6px 0px lightgrey;
  td {
    border-top: 0;
    padding: 20px !important;
    &:first-child {
      // padding-left: 25px !important;
      border-top-left-radius: 0.5rem;
      border-bottom-left-radius: 0.5rem;
    }

    &:last-child {
      border-top-right-radius: 0.5rem;
      border-bottom-right-radius: 0.5rem;
    }
  }
}

.tableRowClass:hover {
  transform: translateY(0);
  // -webkit-box-shadow:  0 4px 20px 0px lightgrey;  /* Safari 3-4, iOS 4.0.2 - 4.2, Android 2.3+ */
  // -moz-box-shadow:     0 4px 20px 0px lightgrey;  /* Firefox 3.5 - 3.6 */
  // box-shadow:          0 4px 6px 0px lightgrey;
}

.tableHeadClass {
  background: none !important;
  border: none !important;
  // text-align: center;
  // padding-left: 25px !important;
}
.tableRowClass:hover {
  .tableTitle {
    color: #7367f0 !important;
  }
}

.button-mt {
  margin-top: 25px;
}
</style>
